import React, { useContext } from 'react';
import Chat from '../chat/Chat';
import { useActiveTenant } from '../../../contexts/ActiveTenantContext';
import { usePermissions } from '../../../contexts/PermissionsContext';
import AdminIndex from './AdminIndex';
import NoTenants from './NoTenants';
import { AuthContext } from '../../../contexts/AuthContext';

const DefaultPage: React.FC = () => {
  const auth = useContext(AuthContext);
  const { activeTenant } = useActiveTenant();
  const { isSiteAdmin } = usePermissions();

  console.log('activeTenant', activeTenant);
  console.log('isSiteAdmin', isSiteAdmin);
  console.log('auth', auth);

  if (auth.loading) return <></>;

  if (activeTenant) {
    return <Chat />;
  } else if (isSiteAdmin) {
    return <AdminIndex />;
  } else {
    return <NoTenants />;
  }
};

export default DefaultPage;
